import React, {useEffect, useState} from "react";


import {
    Row, Col
} from "react-bootstrap";


import {
    ButtonComponent
} from "@Components/Forms";


import IconCheckSmBrown from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Steps/@Icons/icon-check-sm-brown.svg";
import IconCheckedRoundSmGreen from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Steps/@Icons/icon-checked_round-sm-green.svg";
import IconBagdeCheckedSmGreen from "./@Icons/icon-badge_checked-sm-green.svg";

import {RefundOptionsCategoriesObject, UserSubmitRequestDataInterface} from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest";
import {CheckboxFieldComponent, DefaultLoaderComponent} from "@Elements";
import IconPenSmBrown from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Steps/@Icons/icon-pen-sm-brown.svg";
import {SvgIconComponent} from "@Components/Elements";


import "./index.scss";
import IconAttachFileSmBlack
    from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Steps/@Icons/icon-attach_file-sm-black.svg";
import {UseQyvoUser} from "@Store/@Hooks";


interface UserDashboardSubmitRequestStep5ComponentProps {
    userSubmitRequestStepSetter: (step: number) => void;
    userSubmitRequestData: UserSubmitRequestDataInterface;
    userSubmitRequestAttachedFilesList: File[];
}


export const UserDashboardSubmitRequestStep5Component:React.FC<UserDashboardSubmitRequestStep5ComponentProps> = ({
    userSubmitRequestStepSetter,
    userSubmitRequestData,
    userSubmitRequestAttachedFilesList
}) => {


    const QyvoUser = UseQyvoUser();


    const [requestRefundRequestStatus, setRequestRefundRequestStatus] = React.useState(false);

    useEffect(() => {
        return () => {
            setRequestRefundRequestStatus(false);
        };
    }, []);


    const requestRefundRequestHandler = async () => {

        if (!QyvoUser) {
            return;
        }

        setRequestRefundRequestStatus(true);

        const formData = new FormData();

        const {
            refundOptionsStep: refundOptionsList
        } = userSubmitRequestData;

        formData.append('qyvo_user_claim_request_user_id', QyvoUser.qyvoUserID.toString() ?? '');
        formData.append('qyvo_user_claim_request_data', JSON.stringify({ refundOptions: refundOptionsList }));

        formData.append('qyvo_user_claim_request_documents_number', userSubmitRequestAttachedFilesList.length.toString());

        let i = 0;

        for (let claimDocument of userSubmitRequestAttachedFilesList) {
            formData.append(`qyvo_user_claim_request_document_${++i}`, claimDocument, claimDocument.name);
        }

        try {

            const response = await fetch(
                `https://qyvo-engine.webpros.pl/api/v1/qyvo-users/${QyvoUser.qyvoUserID}/create-user-claim-request/`,
                {
                    method: 'POST',
                    body: formData,
                }
            );

            if (response.ok) {
                redirectToSummaryRequestHandler();
            } else {
                console.warn(response);
            }

        } catch (e) {
            console.error(e);
        }

        setRequestRefundRequestStatus(false);

    };


    const redirectToSummaryRequestHandler = () => {
        localStorage.removeItem('storedUserSubmitRequestData');
        userSubmitRequestStepSetter(6);
    };


    const {
        refundOptionsStep: storedRefundOptions,
        personalDataStep: userPersonalData,
        attachedDocumentsStep: { documentsList },
        signatureStep: { signatureType, signatureSrc }
    } = userSubmitRequestData;


    const {
        userFirstName, userLastName,
        userAddressStreet, userAddressHouseNo,
        userAddressPostCode, userAddressCityOrTown
    } = userPersonalData;


    const checkedRefundOptions = new Set<number>(storedRefundOptions);

    const refundOptionsCategoriesList = RefundOptionsCategoriesObject.map((refundCategory) => {

        const {
            refundOptionsCategoryId,
            refundOptionsCategoryOptions,
        } = refundCategory;

        const refundOptionsList = Object.entries(refundOptionsCategoryOptions).map(([refundOptionId, refundOptionName]) => {
            if (!checkedRefundOptions.has(+refundOptionId)) {
                return null;
            }
            return (
                <CheckboxFieldComponent
                    key={refundOptionId}
                    checkboxLabel={refundOptionName}
                    checkboxCheckedStatus={true}
                    checkboxDisabledStatus={true}
                />
            );
        }).filter((refundOptionId) => !!refundOptionId);

        if (!refundOptionsList.length) {
            return null;
        }

        return (
            <Col key={refundOptionsCategoryId} xs={12} className={'user-dashboard-submit-request-step__step-section__section-form__form-sub-section'}>
                <Row className={'user-dashboard-submit-request-step__step-section__section-form__form-sub-section__sub-section-content'}>
                    {refundOptionsList}
                </Row>
            </Col>
        );

    });


    const uploadedDocumentsList = documentsList.map((uploadedDocument, i) => {
        return (
            <Col key={`index-${i}`} xs={12} className={'user-uploaded-document'}>
                <SvgIconComponent iconSource={IconAttachFileSmBlack} />
                <span>{uploadedDocument.userDocumentName}</span>
            </Col>
        );
    });


    const [consentAccepted, setConsentAccepted] = useState(false);

    useEffect(() => {
        return () => {
            setConsentAccepted(false);
        };
    }, []);


    return (
        <Col xs={12} className={'user-dashboard-submit-request-step'}>
            <Row className={'user-dashboard-submit-request-step__step-content'}>

                {requestRefundRequestStatus &&
		            <DefaultLoaderComponent
			            defaultLoaderText={'Submitting Your Request'}
		            />
                }

                <Col xs={12} className={'user-dashboard-submit-request-step__step-header'}>
                    <span className={'user-dashboard-submit-request-step__step-header__main-header'}>Submit a refund request</span>
                </Col>

                <Col xs={12} className={'user-dashboard-submit-request-step__step-section'}>
                    <Row className={'user-dashboard-submit-request-step__step-section__section-content'}>
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-header'}>
                            <span>Type of Refund Request</span>
                        </Col>
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-form'}>
                            <Row className={'user-dashboard-submit-request-step__step-section__section-form__form-content'}>
                                {refundOptionsCategoriesList}
                            </Row>
                        </Col>
                    </Row>
                </Col>

                <Col xs={12} className={'user-dashboard-submit-request-step__step-section'}>
                    <Row className={'user-dashboard-submit-request-step__step-section__section-content'}>
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-header'}>
                            <span>Uploaded documents</span>
                        </Col>
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-form'}>
                            <Row className={'user-dashboard-submit-request-step__step-section__section-form__form-content'}>
                                {uploadedDocumentsList}
                            </Row>
                        </Col>
                    </Row>
                </Col>

                <Col xs={12} className={'user-dashboard-submit-request-step__step-section'}>
                    <Row className={'user-dashboard-submit-request-step__step-section__section-content'}>
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-header'}>
                            <span>Personal Data</span>
                        </Col>
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-content'}>
                            <span>{userFirstName} {userLastName}</span><br/>
                            <span>{userAddressStreet} {userAddressHouseNo}</span><br/>
                            <span>{userAddressPostCode} {userAddressCityOrTown}</span><br/>
                        </Col>
                        {signatureType === 'DIGITAL' &&
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-content user-signature-content'}>
                            <span>Your signature</span>
                            {signatureSrc &&
                            <img src={`data:image/svg+xml;utf8,${encodeURIComponent(signatureSrc)}`} alt={''}/>
                            }
                        </Col>
                        }
                        {signatureType !== 'DIGITAL' &&
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-content user-electronic-signature-content'}>
	                        <SvgIconComponent iconSource={IconBagdeCheckedSmGreen} />
                            <span>The form has been signed with a qualified electronic signature.</span>
                        </Col>
                        }
                    </Row>
                </Col>

                <Col xs={12} className={'user-dashboard-submit-request-step__step-regulations'}>
                    <Row className={'user-dashboard-submit-request-step__step-regulations__regulations-content'}>
                        <CheckboxFieldComponent
                            checkboxLabel={'I consent to submitting the application from my email account.'}
                            checkboxRequiredStatus={true}
                            checkboxCheckedStatus={consentAccepted} checkboxCheckedStatusHandler={() => setConsentAccepted(!consentAccepted)}
                        />
                    </Row>
                </Col>

                {/*<Col xs={12} className={'user-dashboard-submit-request-step__step-communicate'}>*/}
                {/*    <SvgIconComponent iconSource={IconCheckedRoundSmGreen} className={'user-dashboard-submit-request-step__step-communicate__communicate-icon'} />*/}
                {/*    <span className={'user-dashboard-submit-request-step__step-communicate__communicate-text'}>The form has been signed with a qualified electronic signature.</span>*/}
                {/*</Col>*/}

                <Col className={'user-dashboard-submit-request-step__step-buttons'}>
                    <Row className={'user-dashboard-submit-request-step__step-buttons__buttons-content centered-buttons-content'}>
                        {/*<ButtonComponent*/}
                        {/*    size={'l'}*/}
                        {/*    text={'Submit a refund request'} iconRight={IconCheckSmBrown}*/}
                        {/*    callback={() => redirectToSummaryRequestHandler()}*/}
                        {/*/>*/}
                        <ButtonComponent
                            size={'l'}
                            text={'Sign a form'} iconRight={IconPenSmBrown}
                            callback={() => requestRefundRequestHandler()}
                            buttonDisabled={!consentAccepted}
                        />
                    </Row>
                </Col>

            </Row>
        </Col>
    );

};


export default UserDashboardSubmitRequestStep5Component;
